module.exports = __webpack_public_path__ + "img/2-06.9bc3b42a.png";